module.exports = __webpack_public_path__ + "img/header-engagementRingsRosegold@2x.f86abff.jpg";